import React from 'react'
import { fadeIn} from 'react-animations'
import styled, { keyframes } from 'styled-components';
import './Situation.css'

export const Introduction = (props) => {
    const a1 = keyframes`${fadeIn}`;
    const AnimateContent = styled.div`animation: 2s ${a1};`;

  return (
    <div className="introduction">
        <p>Dear {props.name}</p>
        <AnimateContent>
            <p>Welcome to InspireOne’s <span>“Leadership Behaviour Assessment”</span> (Powered by Artificial Intelligence)!</p>
            <p>The Leadership Behavior Assessment is  based on <b>the High-Performance Behaviour framework  for leaders, (HPB™).</b> The <b>HPB  framework</b>  comprises of 12 high performance behaviours  for leaders, organized into 4 clusters. Research of over 2 decades  and work with more than 25000 global leaders has led to this framework. </p>
            <p><span>The Leadership Behaviour Assessment</span>  is a differentiated assessment, in that:</p>
            <ul>
                <li>It is based on the researched High Performance Behaviours framework.</li>
                <li>It is an evidence-based report that  draws  insights from your responses of how you would handle complex leadership situations.</li>
                <li>It provides insights on your demonstration of the High-Performance Behaviours on the job.</li>
                <li>It could prepare you for development in your current and  future roles.</li>
                <li>It is powered by Artificial Intelligence  - Watson (IBM’s AI engine).</li>
            </ul>
            <p>The report will be generated based on your responses to situations that you may face in your role as a leader. </p>
            <p><span>Please read the instructions carefully before responding to the situations.</span> These are critical so that the report generation is smooth.</p>
            {/* <p>In case of any glitches please reach out to <a href="mailto:chandniarneja@inspireone.in">chandniarneja@inspireone.in</a>  </p> */}
        </AnimateContent>
        <p>Best of luck </p>
    </div>
  )
}
